var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"rank"},_vm._l((_vm.ranks),function(rank,index){return _c('rank-item',{directives:[{name:"show",rawName:"v-show",value:(index<=5),expression:"index<=5"}],key:index,attrs:{"name":rank.name,"avatar":rank.avatar,"percent":rank.percentage,"revenue":rank.formated_revenue}})}),1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-217d5a16","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Rank.vue
// module id = null
// module chunks = 